


































































































































































































































    import { Component, Watch, RightHelper } from "../../../Infrastructure/CorBase/CoreBase";
	import TagDetailBase from "./TagDetailBase";

	@Component
	export default class TagDetail extends TagDetailBase {
        hideColor = false;
        showEditColor = false;

        clickToColor() {
            if (this.formIsInEditMode) {
                if (this.hideColor) {
                    this.showEditColor = false;
                    this.hideColor = false;
                }
                else {
                    this.showEditColor = true;
                    this.hideColor = true;
                }
            }
        }

        disableAddButton() {
            return this.formData.id == 0;
        }

        styleColor() {
            return this.formIsInEditMode ? "cursor: pointer;" : "cursor: default;";
        }

        mainColor() {
            return "display: block;   width:100%; height:28px;background-color: "+ this.formData.color;
        }
     
        colorItem(item: string) {
            return " display: block;  border-radius: 5px; cursor: pointer;background-color: " + item + ";";
        }

        items70 = ['#D95626', '#BBD926', '#26D935', '#26D3D9', '#2635D9', '#BE26D9', '#D92656'];
        items50 = ['#BF6240', '#AABF40', '#40BF4A', '#40BBBF', '#404ABF', '#AC40BF', '#BF4062'];

        showEditColore() {
        }

        selectColor(item: string) {
            this.selectColorBase(item);
        }

        hideEditColor() {
            if (this.formIsInEditMode) {
                this.hideColor = true;
            }
        }

        textValueS() {
            return "S (" + this.valueS + ")";
        }

        textValueH() {
            return "H (" + this.valueH + ") 0 - 360";
        }

        textValueL() {
            return "L (" + this.valueL + ") 50 -  70";
        }

		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
        }



        goToDetailReceiver(id: number) {
            var item = this.receivers.filter((c: any) => c.id == id)[0];
            this.$router.push({ name: item.pageDetail , params: { id:  item.id.toString() }, query: { id: item.id.toString(), type: 'detail' } });
        }

        close() {
            this.$emit('goBack', this.formData);
        }

		addSubDetail() {
			this.addSubDetailBase();
		}

		showSaveAll(): boolean {
			return this.isEditDetail && !this.formIsInEditMode;
		}

		deleteSubDetail(item: any) {
			this.deleteSubDetailBase(item);
		}

		mounted() {
			super.mounted(false);
			this.loadFormData();
		};

        isModal() {
            return this.design == "modal";
        }

		get getClassContainer() {
			return {
				"tab-page-main": this.design != "modal",
				"tab-page": this.design == "modal"
			};
		}

		get getClassTabMenu() {
			return {
				"tabMenu": true,
				"helpBorderLeftRight1px": this.design == "modal"
			};
		}

        get getStyleDescription() {
            return {
                "margin-top:0px;": this.design == "modal"
            };
        }

		get gapDesign() {
			return {
				"gapTableDetail": true,
			//	"helpBorderLeftRight1px": this.design == "modal"
			}
		}

		created() {
			
			super.initializeRights('COR_Tag_Create', 'COR_Tag_Delete', 'COR_Tag_Read', 'COR_Tag_Update');
			this.canRead = this.canRead || RightHelper.currentUserHasRight('CON_Receiver_Read');
			if (this.canRead) {
				this.hasRight = true;
			}
			super.setMainDescription('tag.new', 'tag.detail');
            this.createdBase();
            this.mainDataChanged = false;
		}

       
        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && ((this.formIsInEditMode && this.dataWasChanged()) || this.mainDataChangedSub)) {
                event.preventDefault(); event.returnValue = "";
            }
        }
       
        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }
        
        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}

		selectedItems(items: any): void {
			this.selectedItemsBase(items);
		}

        //@ts-ignore
		@Watch('$i18n.locale')
		changeLanguage(value: boolean, oldValue: boolean) {
			this.changeLanguageBase(value, oldValue);
        }


        private receiverNotChanged() {
            this.mainDataChangedSub = !this.receiverNotChangeBase();
            return this.receiverNotChangeBase();
        }


        
	}
